import { ConfigValue } from './ConfigValue'

export type ConfigKeys = keyof typeof defaultConfig
export type ConfigType = Record<ConfigKeys, any>
export type RemoteConfigType = Record<keyof ConfigType, ConfigValue>

export const defaultConfig = {
  test: 'true', // for testing purposes
  showFacilityScore: 'true',
  kamionIntegrationSurvey:
    '{ "text": "", "textFeedback": "", "feedbackDelay": 0, "buttonLabel": "", "enabled": false, "roleRestriction": [], "storageKey": "", "target": ""}',
  advertisingBannerConfig: JSON.stringify({
    '5': {
      display: 'false',
      bannerText: '',
      bannerTextVariant: '',
      buttonText: '',
      bannerBackgroundColor: '',
      bannerTextColor: '',
      buttonVariant: '',
      buttonURL: '',
      buttonTextColor: '',
      bannerBackgroundImage: '',
    },
  }),
  enableQuoteAccessorials: 'false',
  enableShipmentChargesForBrokerage: 'false',
  enableShipmentChargesForFbm: 'false',
  enableShipmentAppointment: 'false',
  configAnnouncement: '{}',
  enablePriceItemTypes: 'false',
  enableShipmentNumberFilter: 'false',
  enablePaginatedRfpList: 'false',
  enableNewTrackingVisibilty: 'false',
  enableTrackingOnboarding: 'false',
  enableEmbeddedAudit: 'false',
  enableShipperGuidePage: 'false',
  enableShipperGuideDecomission: 'false',
  enableProofOfPickup: 'false',
  enableDocumentStopSelection: 'false',
  enableAttachmentsEndpointForPods: 'false',
  enableTenderListPage: 'false',
  enableShipperListPage: 'false',
  enableShipmentGlobalSearch: 'false',
  enableShipmentsMetadata: 'false',
  disableBrokerageFeatures: 'false',
  enableMultiShipperBids: 'false',
  enableNewOpenDockReschedulingDrawer: 'false',
  enableUploadShipperDocuments: 'false',
}

export function getConfigValues(config: ConfigType) {
  return Object.entries(config).reduce((acc: RemoteConfigType, current: [string, string]) => {
    const [configName, value] = current

    const configValue = new ConfigValue(value)

    return { ...acc, [configName]: configValue }
  }, {} as RemoteConfigType)
}

export const defaultConfigValues = getConfigValues(defaultConfig)
